import createCache from "@emotion/cache";

/**
 * Creates a scoped Emotion cache. Useful for Shadow DOM integration.
 * @param container DOM node to contain injected styles (e.g., shadowRoot or document.head)
 */
const createEmotionCache = (container: HTMLElement | ShadowRoot) => {
  let target: HTMLElement;

  if (container instanceof ShadowRoot) {
    let styleHost = container.querySelector<HTMLElement>("#cosid-emotion");
    if (!styleHost) {
      styleHost = document.createElement("div");
      styleHost.id = "cosid-emotion";
      container.appendChild(styleHost);
    }
    target = styleHost;
  } else {
    target = container;
  }

  return createCache({ key: "cosid", container: target });
};

export default createEmotionCache;
